module.exports = __webpack_public_path__ + "static/media/menu-icon.eba38a90.svg";